import type { FunctionComponent } from 'react';
import map from 'lodash/map';
import { ReactComponent as FutureSVG } from './future-box.svg';
import { ReactComponent as ShippedSVG } from './shipped-box.svg';
import { ReactComponent as SkippedSVG } from './skipped-box.svg';
import * as styles from './RemainingBoxes.module.css';

const ORDER_STATE = {
  shipped: 'SHIPPED',
  skipped: 'SKIPPED',
  refund: 'REFUND',
};

const boxSVGs = {
  SHIPPED: <ShippedSVG />,
  ASSIGNED: <FutureSVG />,
  FUTURE: <FutureSVG />,
  SKIPPED: <SkippedSVG />,
};

type RemainingBoxesProps = {
  remainingBoxes: {
    orderState: string;
    season: string;
  }[];
};

const RemainingBoxes: FunctionComponent<RemainingBoxesProps> = ({ remainingBoxes }) => {
  return (
    <div className={styles.container}>
      <h4>Remaining Boxes in My Subscription</h4>
      <div className={styles.boxContainer}>
        {map(remainingBoxes, (box) => {
          const { orderState, season } = box;
          const isSkippedBox = orderState === ORDER_STATE.skipped;
          const isPastBox = orderState === ORDER_STATE.shipped || isSkippedBox;
          if (orderState === ORDER_STATE.refund) return null;
          return (
            <div key={season}>
              {boxSVGs[orderState as keyof typeof boxSVGs]}
              <p style={isPastBox ? { opacity: '0.4' } : undefined}>
                {isSkippedBox ? orderState : season}
              </p>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default RemainingBoxes;
